import { useState } from "react";

export default function useBooleanToggle(defaultValue = false) {
  const [value, setValue] = useState(defaultValue);

  const toggle = () => setValue(!value);
  const setTrue = () => setValue(true);
  const setFalse = () => setValue(false);

  const helpers = { toggle, setTrue, setFalse };

  return [value, helpers] as const;
}
